import { ColumnDefaultProps } from '../ColumnProps';
/**
 * @hidden
 */
export function mapColumns(columns) {
    var columnsMap = [[]];
    var stickyLeftWidth = 0;
    for (var q = columns.length - 1; q >= 0; q--) {
        columns[q].colSpan = columns[q].colSpan || 1;
        if (columns[q].parentIndex !== -1) {
            columns[columns[q].parentIndex].colSpan =
                (columns[columns[q].parentIndex].colSpan || 0) + columns[q].colSpan;
        }
    }
    var maxDepth = 0;
    columns.forEach(function (d) { maxDepth = Math.max(maxDepth, d.depth); });
    var rowSpan = 1;
    columns.forEach(function (column, i) {
        columnsMap[column.depth] = columnsMap[column.depth] || [];
        var needKFirst = false;
        if (columnsMap[column.depth].length === 0) {
            if (rowSpan <= 1) {
                rowSpan = 1 + (column.children.length > 0 ? 0 : maxDepth - column.depth);
            }
            else {
                rowSpan--;
                needKFirst = true;
            }
        }
        column.rowSpan = 1 + (column.children.length > 0 ? 0 : maxDepth - column.depth);
        column.kFirst = needKFirst;
        column.index = columnsMap[column.depth].length;
        columnsMap[column.depth].push(i);
        if (column.locked && column.children.length === 0) {
            column.left = stickyLeftWidth;
            stickyLeftWidth += column.width ? parseFloat(column.width.toString()) : 0;
        }
    });
    var nextIsLocked = false;
    var stickyRightWidth = 0;
    for (var i = columns.length - 1; i >= 0; i--) {
        var column = columns[i];
        if (column.locked && column.children.length === 0) {
            column.right = stickyRightWidth;
            stickyRightWidth += column.width ? parseFloat(column.width.toString()) : 0;
            column.rightBorder = !nextIsLocked;
        }
        nextIsLocked = column.locked || false;
    }
    return columnsMap;
}
/**
 * @hidden
 */
export function readColumns(elements, depth) {
    if (depth === void 0) { depth = 0; }
    var columns = [];
    if (!elements || !elements.length) {
        return [];
    }
    elements.forEach(function (columnProps) {
        var children = readColumns(columnProps.children || [], depth + 1);
        columns.push(Object.assign({}, { depth: depth }, ColumnDefaultProps, columnProps, {
            declarationIndex: columns.length,
            children: children,
            rowSpan: 0,
            colSpan: 0
        }));
    });
    var comparator = function (a, b) {
        return a.orderIndex === b.orderIndex ?
            a.declarationIndex - b.declarationIndex :
            ((a.orderIndex || 0) - (b.orderIndex || 0));
    };
    columns.sort(comparator);
    if (depth === 0) {
        var ret_1 = [];
        var flat_1 = function (cols, pIndex) {
            return cols.forEach(function (c) {
                c.parentIndex = pIndex;
                flat_1(c.children, ret_1.push(c) - 1);
            });
        };
        flat_1(columns, -1);
        return ret_1;
    }
    return columns;
}
/**
 * @hidden
 */
export function isRtl(element) {
    return Boolean(element && getComputedStyle(element).direction === 'rtl');
}
/**
 * @hidden
 */
export function getIndex(event, parent) {
    if (!parent || !event || !event.originalEvent) {
        return -1;
    }
    var target = document.elementFromPoint(event.clientX, event.originalEvent.clientY);
    while (target && target.parentElement !== parent) {
        target = target.parentElement;
    }
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
        if (children[i] === target) {
            return i;
        }
    }
    return -1;
}
//# sourceMappingURL=index.js.map